'use client';
import { rgba } from '../../../../../../fns/rgba/rgba.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var deriveBackgroundShades = function(neutral, white) {
    return _extends({}, neutral && white && {
        content: {
            day: white[100],
            night: neutral[920]
        },
        content2: {
            day: white[100],
            night: neutral[900]
        },
        content3: {
            day: white[100],
            night: neutral[700]
        },
        elementOnColor: {
            day: white[100],
            night: neutral[40]
        },
        elementOnColor2: {
            day: rgba(white[100], 0.2),
            night: rgba(neutral[40], 0.16)
        }
    }, neutral && {
        highlight: {
            day: neutral[20],
            night: neutral[900]
        },
        highlight2: {
            day: neutral[20],
            night: neutral[500]
        },
        back: {
            day: neutral[30],
            night: neutral[950]
        },
        elementWeak: {
            day: neutral[30],
            night: neutral[900]
        },
        element: {
            day: neutral[40],
            night: neutral[950]
        }
    });
};

export { deriveBackgroundShades };
